import * as types from './mutation-types'
import { Auth } from '../api'
import Basic from '../api/basic'

export default {
  setSearchParam: ({ commit }, data) => {
    console.log('loadSearchParam setSearchParam', data)
    const payload = [data.data, data.target]
    commit(types.FETCH_ALL_SEARCHPARAM, payload)
  },
  setPager: ({ commit }, data) => {
    console.log('setPager', data)
    const payload = []
    payload[data.target] = data.data
    commit(types.FETCH_ALL_PAGER, payload)
  },
  login: ({ commit }, authInfo) => {
    return Auth.login(authInfo)
      .then(
        ({ token, userId, label, level, year, relations, limit_timestamp }) => {
          localStorage.setItem('token', token)
          commit(types.AUTH_LOGIN, {
            token,
            userId,
            label,
            level,
            year,
            relations,
            limit_timestamp
          })
          console.log(
            'logincheck l',
            token,
            userId,
            label,
            level,
            year,
            relations,
            limit_timestamp
          )
        }
      )
      .catch(err => {
        throw err
      })
  },
  tokenLogin: ({ commit }, authInfo) => {
    return Auth.tokenLogin(authInfo)
      .then(
        ({ token, userId, label, level, year, relations, limit_timestamp }) => {
          localStorage.setItem('token', token)
          commit(types.AUTH_LOGIN, {
            token,
            userId,
            label,
            level,
            year,
            relations,
            limit_timestamp
          })
          console.log('logincheck t', token, userId, label, level, year)
          return {
            token: token,
            userId: userId,
            label: label,
            level: level,
            year: year,
            relations: relations,
            limit_timestamp: limit_timestamp
          }
        }
      )
      .catch(err => {
        throw err
      })
  },
  logout: ({ commit, state }) => {
    return Auth.logout(state.auth.token)
      .then(() => {
        localStorage.removeItem('token')
        commit(types.AUTH_LOGOUT, { token: null, userId: null })
      })
      .catch(err => {
        throw err
      })
      .finally(() => {
        localStorage.removeItem('token')
        commit(types.AUTH_LOGOUT, { token: null, userId: null })
      })
  },

  fetchBasicLists: ({ commit, state }, data, target, targetF) => {
    console.log('commit fetch basic lists:', data, target, targetF)
    return Basic.fetch(state.auth.token, data, target, targetF)
      .then(({ basic, target, pager, search_param }) => {
        console.log('actions fetch basic', basic, target, pager, search_param)
        const payload = [basic, target]
        commit(types.FETCH_ALL_BASICLIST, payload)
        if (pager) {
          commit(types.FETCH_ALL_PAGER, pager)
        }
        if (search_param) {
          commit(types.FETCH_ALL_SEARCHPARAM, search_param)
        }
      })
      .catch(err => {
        throw err
      })
  },

  updateBasic: ({ commit, state }, data, target) => {
    // console.log('actions.js 開始', data);
    return new Promise((resolve, reject) => {
      Basic.update(state.auth.token, data, target)
        .then(res => {
          console.log('updateBasic AAAA', res)
          commit(types.UPDATE_BASIC, data, target)
          resolve(res)
        })
        .catch(err => {
          console.log('updateBasic ERR', err)
          reject(err)
        })
      // .catch(err => { throw err })
    })
    // return Basic.update(state.auth.token, data, target)
    //   .then((res) => {
    //     console.log('updateBasic AAAA', res);
    //     commit(types.UPDATE_BASIC, data, target);
    //     // resolve(res);
    //   })
    //   .catch(err => { throw err })
  }
}
